//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from 'js-md5'
// @ is an alias to /src
import { Toast } from 'mint-ui'
const config = window.config
export default {
  name: 'bind-phone-page',
  data() {
    return {
      mobile: '',
      password: '',
      timer: null,
      TIME_COUNT: 60,
      marginTop: 300
    }
  },
  mounted () {
    this.marginTop = document.documentElement.clientHeight * 0.4
    this.getCustomers()
  },
  methods: {
    sendSMS () {
      const setTimer = () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.TIME_COUNT > 0) {
            this.TIME_COUNT--
            setTimer()
          } else {
            this.TIME_COUNT = 60
          }
        }, 1000)
      }
      if (!this.mobile) {
        return Toast({
          message: '請填寫手機號',
          duration: 3000
        })
      }
      if (this.TIME_COUNT !== 60) {
        return Toast({
          message: `請在${this.TIME_COUNT}秒後重新發送`,
          duration: 3000
        })
      }
      this.TIME_COUNT--
      setTimer()
      this.$store.httpDispatch({})('sendSMS', {
        mobile: this.mobile
      })
      .then((res) => {
        if (res.data.code === 0) {
          Toast({
            message: '發送成功',
            duration: 3000
          })
        }
      })
      .catch((err) => {
        Toast({
          message: `${err.data.code}: ${err.data.msg}`,
          duration: 5000
        })
      })
    },
    getCustomers () {
      this.$store.httpDispatch({})('getSetting')
      .then((res) => {
        if (res.data.code === 0) {
          this.froms = res.data.data.setting.list
          this.fromState = this.froms[0] || ''
        }
      })
    },
    bindMobile () {
      if (!this.mobile) {
        return Toast({
          message: '請填寫手機號',
          duration: 3000
        })
      }
      if (!this.password) {
        return Toast({
          message: '請填寫登錄密碼',
          duration: 3000
        })
      }
      const password = this.password ? md5(this.password) : ''
      this.$store.httpDispatch({})('loginByMobile', {
        mobile: this.mobile,
        password: password,
      }).then((res) => {
        if (res.data.code === 0) {
          const { code, data } = res.data
          data.tokenExpiredAt = new Date(data.tokenExpiredAt)
          localStorage.setItem('token', data.token)
          this.$store.commit('ACCOUNT_RESTORE', {
            tokenExpiredAt: data.tokenExpiredAt,
            token: data.token
          })
          localStorage.setItem('tokenExpiredAt', data.tokenExpiredAt.getTime())
          this.$store.dispatch('setUser', { user: data.user })
          this.$router.push('/')
        }
      })
      .catch((err) => {
        if (err.data.code === 4010001) {
          console.log(err)
          Toast({
            message: `${err.data.code}: 用戶名或密碼錯誤`,
            duration: 5000
          })
        } else {
          console.log(err)
          Toast({
            message: `${err.data.code}: ${err.data.msg}`,
            duration: 5000
          })

        }
      })
    }
  }
}
